import { StorageService } from '../services/storage.service';

// Save a value in storage as a string
export function saveToLocalStorage(key: string, value: string | boolean) {
    // Note: This function is kept for backward compatibility
    // In new code, prefer using StorageService directly
    const storageService = new StorageService();
    storageService.set(key, String(value));
}

// Update the direction attribute (ltr or rtl) on the HTML document
export function updateHtmlDirection(direction: string) {
    document.querySelector('html')?.setAttribute('dir', direction || 'ltr');
}

// Add or remove the 'dark' class on the body element depending on dark mode status
export function applyDarkMode(enable: boolean) {
    const body = document.querySelector('body');
    if (enable) {
        body?.classList.add('dark');
    } else {
        body?.classList.remove('dark');
    }
}

// Apply CSS animation by adding classes to the target element
export function applyAnimation(animation?: string) {
    const animationElement = document.querySelector('.animation');
    if (!animation || !animationElement) return;

    animationElement.classList.add('animate__animated', animation);
}

// Determine if dark mode should be enabled based on the theme
export function determineDarkMode(theme: string): boolean {
    if (theme === 'light') return false;
    if (theme === 'dark') return true;
    if (theme === 'system') {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
}
